import { useContext, createContext, useMemo, useState, useEffect } from 'react';

//Context
export const AuthContext = createContext(null);

//Provider
export const AuthContextProvider = ({ children }) => {

  const [afiliado, setAfiliado] = useState({});

//   useEffect(() => {

//   }, []);

    // useEffect(() => {
    //     console.log("AuthContextProvider Render")
    // });

    const values = useMemo(() => ({ 
            afiliado,       // States que seran visibles en el contexto.
            setAfiliado,    // Funciones que son exportadas para manejo externo.
        }), 
        [ afiliado ]
    );      

  // Interfaz donde será expuesto como proveedor y envolverá la App.
  return <AuthContext.Provider value={values}>{children}</AuthContext.Provider>;
}

// Consumidor
export function useAuthContext() {
  const context = useContext(AuthContext);

  if(!context){
    console.error('Error deploying App AuthContext!!!');
  }

  return context;
}

export default useAuthContext;